<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <setup-positions-categories-dialog-create @created="created" />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-for="category in categories"
        :key="category.id"
        cols="12"
      >
        <v-card class="elevation-2 pa-2">
          <v-card-actions>
            <v-btn 
              icon
              text 
              @click="onClickHandler(category.id)"
            >
              <v-icon>{{ shows[category.id] ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
            </v-btn>
            <span class="title text-capitalize text-truncate">{{ category.name }}</span>
            <v-spacer />
            <setup-positions-categories-dialog-edit 
              :category="category"
              @updated="loadCategories"
            />
            <setup-positions-categories-dialog-delete 
              :category="category"
              @deleted="loadCategories"
            />            
          </v-card-actions> 
          <v-divider dark />   
          <v-container v-show="shows[category.id]">
            <v-row>
              <v-col>
                <v-card class="elevation-5">
                  <v-toolbar 
                    flat
                    color="white"
                  >
                    <v-toolbar-title>Grades</v-toolbar-title>
                    <v-spacer />
                    <div class="hidden-sm-and-down">
                      <setup-positions-categories-ranks-dialog-create
                        :category="category"
                        @created="loadGrades(category.id, true)"
                      />
                    </div>
                  </v-toolbar>
                  <v-data-table
                    :headers="headers"
                    :items="grades[category.id]"
                    :loading="loadingGrades[category.id]"
                  >
                    <template v-slot:item.icon="{ item }">
                      <v-avatar 
                        tile
                      >
                        <img :src="item.image_url">       
                      </v-avatar>                             
                    </template>     
                    <template v-slot:item.action="{ item }">   
                      <setup-positions-categories-ranks-dialog-edit
                        :grade="item.pivot"
                        @updated="loadGrades(category.id, true)"
                      />
                      <setup-positions-categories-ranks-dialog-delete
                        :grade="item.pivot"
                        @deleted="loadGrades(category.id, true)"
                      />
                    </template>              
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
          </v-container>          
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-show="categories.length === 0 && loading === false"
      justify="center"
    >
      <v-col
        class="text-center"
        cols="12"
      >
        <div class="headline">
          <span class="blue-grey--text">No Data Available</span>
        </div>
      </v-col>   
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupPositionsCategoriesDialogCreate: () => import('@/components/setup/positions/categories/DialogCreate'),
      SetupPositionsCategoriesDialogDelete: () => import('@/components/setup/positions/categories/DialogDelete'),
      SetupPositionsCategoriesDialogEdit: () => import('@/components/setup/positions/categories/DialogEdit'),
      SetupPositionsCategoriesRanksDialogCreate: () => import('@/components/setup/positions/categories/ranks/DialogCreate'),
      SetupPositionsCategoriesRanksDialogEdit: () => import('@/components/setup/positions/categories/ranks/DialogEdit'),
      SetupPositionsCategoriesRanksDialogDelete: () => import('@/components/setup/positions/categories/ranks/DialogDelete'),
    },
    metaInfo () {
      return {
        title: 'Setup - Position Categories',
      }
    },
    data () {
      return {
        loading: true,
        loadingGrades: [],
        categories: [],
        grades: [],
        shows: [],
        headers: [
          {
            text: 'Rank',
            align: 'left',
            value: 'value',
          },
          {
            text: 'Badge',
            align: 'left',
            sortable: false,
            value: 'icon',
          },
          {
            text: 'Title',
            align: 'left',
            sortable: false,
            value: 'title',
          },
          {
            text: 'Name',
            align: 'left',
            value: 'pivot.name',
          },
          {
            text: 'Description',
            align: 'left',
            sortable: false,
            value: 'pivot.description',
          },
          { 
            text: 'Actions', 
            sortable: false, 
            value: 'action',
          },
        ],
      }
    },
    created () {
      this.loadCategories()
    },
    methods: {
      onClickHandler (id) {
        this.$set(this.shows, id, !this.shows[id])

        this.loadGrades(id)
      },
      loadGrades (categoryId, forceRefresh = false) {
        if ((this.grades[categoryId] || []).length > 0 && !forceRefresh) return

        this.$set(this.loadingGrades, categoryId, true)

        this.$api.grades().list(categoryId)
          .then(response => {
            this.$set(this.grades, categoryId, response.data)

            this.$set(this.loadingGrades, categoryId, false)
          })
      },
      loadCategories () {
        this.$api.positionCategories().list()
          .then(response => {
            this.categories = response.data
            this.loading = false
          })
      },
      created (category) {
        this.categories.unshift(category)
      },
    },
  }
</script>

<style scoped>
   ::v-deep .v-toolbar__content{
    margin-left:0px !important;
  }
</style>
